export enum WysiwygLayoutEnum {
  TEXT_CENTERLEFT_MEDIA_RIGHT = 'TEXT_CENTERLEFT_MEDIA_RIGHT',
  TEXT_TOPLEFT_MEDIA_RIGHT = 'TEXT_TOPLEFT_MEDIA_RIGHT',
  TEXT_TOPRIGHT_MEDIA_LEFT = 'TEXT_TOPRIGHT_MEDIA_LEFT',
  TEXT_CENTERRIGHT_MEDIA_LEFT = 'TEXT_CENTERRIGHT_MEDIA_LEFT'
}
